export default "__VITE_ASSET__BO4q2CCm__"